export * from './response';
export * from './ticket';
export * from './user';
export * from './menu';
export * from './form-data';
export * from './role';
export * from './division';
export * from './snackbar-format';



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/models/index.ts